import { useCallback } from 'react';
import Dialog from '@mui/material/Dialog';
import MuiButton from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

import { FCX } from '@core/models';
import Button from '@components/Button';
import { CloseSurveyParams, useCloseSurvey } from '@core/api/useSurveys';
import { toast } from "react-toastify";

const CloseSurveyPopup: FCX<{
    open: boolean;
    onCloseSurveyCallback: () => void;
    handleClosePopup: () => void;
    surveyId?: number;
}> = ({
    open,
    onCloseSurveyCallback,
    handleClosePopup,
    surveyId
}) => {
    const { doFetch } = useCloseSurvey();

    const onCloseSurvey = useCallback(() => {
        const params: CloseSurveyParams = {
            surveyId: surveyId,
        };

        doFetch({
            params,
        })
            .then(() => {
                toast.success('Survey closed successfully');
                onCloseSurveyCallback();
            })
            .catch(() => {
                toast.error('Survey close failed');
            })
            .finally(() => {
                handleClosePopup();
            });
    }, [doFetch, handleClosePopup, onCloseSurveyCallback, surveyId]);

    return (
        <Dialog open={open} onClose={() => handleClosePopup()}>
            <DialogTitle>{'Close'}</DialogTitle>
            <DialogContent dividers>Are you sure you want to close this survey?</DialogContent>
            <DialogActions>
                <MuiButton color="inherit" onClick={handleClosePopup}>
                    Cancel
                </MuiButton>
                <Button onClick={onCloseSurvey}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default CloseSurveyPopup;
